// Lightweight brand data for layout components (Header, Footer, CategoryNav, homepage).
// Importing the full @/data/brands pulls 341 KB of brand descriptions, FAQs, models etc.
// that layout components never need — they only render brand name/slug as a link/logo.
// Routes that genuinely need full BrandConfig (sitemap, /reservdelar/[brand], category pages)
// keep importing from @/data/brands directly.

export interface BrandLite { slug: string; name: string; logo: string }

export const brandsLite: BrandLite[] = [
  { slug: 'peugeot', name: 'Peugeot', logo: 'peugeot.png' },
  { slug: 'renault', name: 'Renault', logo: 'renault.png' },
  { slug: 'citroen', name: 'Citroën', logo: 'citroen.png' },
  { slug: 'dacia', name: 'Dacia', logo: 'dacia.png' },
  { slug: 'volvo', name: 'Volvo', logo: 'volvo.png' },
  { slug: 'volkswagen', name: 'Volkswagen', logo: 'vw.png' },
  { slug: 'bmw', name: 'BMW', logo: 'bmw.png' },
  { slug: 'audi', name: 'Audi', logo: 'audi.png' },
  { slug: 'mercedes', name: 'Mercedes-Benz', logo: 'mercedes-benz.png' },
  { slug: 'ford', name: 'Ford', logo: 'ford.png' },
  { slug: 'opel', name: 'Opel', logo: 'opel.png' },
  { slug: 'toyota', name: 'Toyota', logo: 'toyota.png' },
  { slug: 'hyundai', name: 'Hyundai', logo: 'hyundai.png' },
  { slug: 'nissan', name: 'Nissan', logo: 'nissan.png' },
  { slug: 'skoda', name: 'Škoda', logo: 'skoda.png' },
  { slug: 'fiat', name: 'Fiat', logo: 'fiat.png' },
  { slug: 'honda', name: 'Honda', logo: 'honda.png' },
  { slug: 'seat', name: 'SEAT', logo: '104.png' },
  { slug: 'kia', name: 'Kia', logo: '184.png' },
  { slug: 'mazda', name: 'Mazda', logo: '72.png' },
  { slug: 'mitsubishi', name: 'Mitsubishi', logo: '77.png' },
  { slug: 'alfa-romeo', name: 'Alfa Romeo', logo: '2.png' },
  { slug: 'suzuki', name: 'Suzuki', logo: '109.png' },
  { slug: 'land-rover', name: 'Land Rover', logo: '1820.png' },
  { slug: 'saab', name: 'Saab', logo: '99.png' },
  { slug: 'mini', name: 'MINI', logo: '1523.png' },
  { slug: 'ds', name: 'DS', logo: '4468.png' },
  { slug: 'tesla', name: 'Tesla', logo: '3328.png' },
  { slug: 'byd', name: 'BYD', logo: '3122.png' },
  { slug: 'polestar', name: 'Polestar', logo: 'polestar.png' },
  { slug: 'porsche', name: 'Porsche', logo: '92.png' }
];

export const popularCategories = [
  { name: 'Bromsanläggning', slug: 'bromsanlaggning' },
  { name: 'Karosseri', slug: 'karosseri' },
  { name: 'Tändsystem', slug: 'tandsystem' },
  { name: 'Koppling', slug: 'koppling' },
  { name: 'Fjädring / Dämpning', slug: 'fjadring-dampning' },
  { name: 'Avgassystem', slug: 'avgassystem' },
  { name: 'Belysning', slug: 'belysning' },
  { name: 'Kylsystem', slug: 'kylsystem' },
  { name: 'Torka / Spola', slug: 'torka-spola' },
  { name: 'Styrning', slug: 'styrning' },
];

export const popularModels: { brand: string; model: string; label: string }[] = [
  { brand: 'peugeot', model: '208', label: 'Peugeot 208' },
  { brand: 'peugeot', model: '308', label: 'Peugeot 308' },
  { brand: 'peugeot', model: '3008', label: 'Peugeot 3008' },
  { brand: 'renault', model: 'clio', label: 'Renault Clio' },
  { brand: 'renault', model: 'megane', label: 'Renault Megane' },
  { brand: 'renault', model: 'captur', label: 'Renault Captur' },
  { brand: 'citroen', model: 'c3', label: 'Citroën C3' },
  { brand: 'citroen', model: 'berlingo', label: 'Citroën Berlingo' },
  { brand: 'volkswagen', model: 'golf', label: 'VW Golf' },
  { brand: 'volkswagen', model: 'passat', label: 'VW Passat' },
  { brand: 'volvo', model: 'xc60', label: 'Volvo XC60' },
  { brand: 'volvo', model: 'v60', label: 'Volvo V60' },
  { brand: 'bmw', model: '3-serie', label: 'BMW 3-serie' },
  { brand: 'toyota', model: 'rav4', label: 'Toyota RAV4' },
  { brand: 'ford', model: 'focus', label: 'Ford Focus' },
];
